import type { ISessionPort } from '@subscriptions/application/ports';

/** Reads the signed-in Parrot user. Amplitude identifies the store, not the person, so an event
 * that names who acted carries this uuid — never the email, which is PII. */
export const getCurrentUserUuidUseCase = (port: ISessionPort) => {
  const execute = (): string | null => port.getUserUuid();

  return { execute };
};

export type GetCurrentUserUuid = ReturnType<typeof getCurrentUserUuidUseCase>;
